import React, { useState } from 'react';
import {
    Img,
    ImgWrap,
    TextWrapper,
    TopLine,
    ProjectionCard,
    FormH4,
    SelectButton,
    ButtonWrap,
    Form,
    UserProjectionInput,
    NextButton,
    ProjectionCardButtonRight,
    ProjectionCardButtonLeft,
    ErrorText
} from './CrewBuilderElements';
import asset from '../../images/asset.jpg'

const UserProjectionCard = ({ player, handleNext, handlePrevious, currentCard, firstCard }) => {
    var projection;
    if (player.projectedStats) {
        projection = player.projectedStats.FantasyPointsDraftKings
    }
    else {
        if (player.ifDefenseProjectedStats) {
            projection = player.ifDefenseProjectedStats.FantasyPointsDraftKings
        }
        else {
            projection = 0.0
        }
    }
    const [playerProjection, setPlayerProjection] = useState(0.0);
    const [errorMessage, setErrorMessage] = useState("");

    const disabled = player.playerID == currentCard ? (false) : true

    const handleSetProjection = (e) => {
        if (!isNaN(Number(e.target.value))) {
            setPlayerProjection(e.target.value);
            setErrorMessage("");
        } else {
            setErrorMessage("Not a valid Projection")
        }
    }
    return (
        <>
            <ProjectionCard>
                <ImgWrap>
                    <Img src={asset} alt={'placeholder'} />
                </ImgWrap>
                <TextWrapper>
                    <TopLine>{player.name}</TopLine>
                    <FormH4>Team: {player.team}</FormH4>
                    <FormH4>Position: {player.position}</FormH4>
                    <FormH4>Salary: ${player.currentSalary}</FormH4>
                    <UserProjectionInput disabled={disabled} type="Float" onChange={(e) => handleSetProjection(e)} />
                    <></>
                </TextWrapper>
                <ErrorText>{errorMessage}</ErrorText>
                {!firstCard ?
                    (
                        <ButtonWrap>
                            <ProjectionCardButtonLeft disabled={disabled} dark={false} primary={true} big={false} fontBig={false} onClick={(l) => handlePrevious(player)}>Previous</ProjectionCardButtonLeft>
                            <ProjectionCardButtonRight disabled={disabled} dark={false} primary={true} big={false} fontBig={false} onClick={(a) => handleNext(playerProjection, player)}>Next</ProjectionCardButtonRight>
                        </ButtonWrap>
                    ) :
                    <ButtonWrap>
                        <SelectButton disabled={disabled} dark={false} primary={true} big={false} fontBig={false} onClick={(a) => handleNext(playerProjection, player)}>Next</SelectButton>
                    </ButtonWrap>
                }
            </ProjectionCard>
        </>
    );
};

export default UserProjectionCard;
